<div class="container offer-recalculation-dialog">
    <h2 class="offer-recalculation-dialog__header">{{ (isHigherPremiumMode ? getTranslationKey('header') : getTranslationKey('headerDiscount')) | translate }}</h2>

    <img *ngIf="imageUrl" class="offer-recalculation-dialog__image"
         [src]="imageUrl"
         alt="">

    <p class="offer-recalculation-dialog__entry-message">{{ getTranslationKey('entryMessage') | translate }}</p>
    <p class="offer-recalculation-dialog__recalculation-message">{{ getTranslationKey('recalculationMessage',
        modeSpecificTranslationsContainer) | translate }}</p>
    <p class="offer-recalculation-dialog__policy-purchase-message">{{ getTranslationKey('policyPurchaseMessage',
        modeSpecificTranslationsContainer) | translate }}</p>

    <div class="offer-recalculation-dialog__details">
        <div class="offer-recalculation-dialog__details--wrapper">
            <div class="offer-recalculation-dialog__details--element offer-recalculation-dialog__premium-before">
                <span class="offer-recalculation-dialog__premium-before--label">{{ getTranslationKey('beforeRecalculation', 'DETAILS') | translate }}</span>
                <app-custom-price
                        class="offer-recalculation-dialog__premium-before--price"
                        [price]="status.amount">
                </app-custom-price>
            </div>
            <div class="offer-recalculation-dialog__details--element offer-recalculation-dialog__premium-after text-blue">
                <span class="offer-recalculation-dialog__premium-after--label">{{ getTranslationKey('afterRecalculation', 'DETAILS') | translate }}</span>
                <app-custom-price
                        class="offer-recalculation-dialog__premium-after--price"
                        [price]="status.newAmount">
                </app-custom-price>
            </div>
            <div class="offer-recalculation-dialog__details--element offer-recalculation-dialog__first-installment">
                <span class="offer-recalculation-dialog__first-installment--label">{{ getTranslationKey('firstInstallment', 'DETAILS') | translate }}</span>
                <app-custom-price
                        class="offer-recalculation-dialog__first-installment--price"
                        [price]="status.newInstalmentAmount">
                </app-custom-price>
            </div>
        </div>
    </div>

    <p *ngIf="isHigherPremiumMode" class="offer-recalculation-dialog__back-to-offers-message">{{
        getTranslationKey('backToOffersMessage') | translate }}</p>

    <div class="offer-recalculation-dialog__actions">
        <button *ngIf="isHigherPremiumMode" (click)="backToOffers()"
                class="offer-recalculation-dialog__button offer-recalculation-dialog__button--back-to-offers btn btn--secondary btn--big">
            {{ getTranslationKey('backToOffersAction') | translate }}
        </button>
        <button (click)="pay()" class="offer-recalculation-dialog__button offer-recalculation-dialog__button--pay btn btn--secondary btn--big">
            {{ getTranslationKey('payAction') | translate }}
        </button>
    </div>
</div>
